import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";

import EquitySwap from "../../components/Equity/EquitySwap";
import BuyEquityIcon from "../../img/logo-equity.png";
import Footer from "../../Footer";
import "./BuyEquity.css";

import { useChainId } from "../../Helpers";
import { getNativeToken } from "../../data/Tokens";

export default function BuyEquity(props) {
  const { chainId } = useChainId();
  const history = useHistory();
  const [isBuying, setIsBuying] = useState(true);
  const nativeTokenSymbol = getNativeToken(chainId).symbol;

  useEffect(() => {
    const hash = history.location.hash.replace("#", "");
    const buying = hash === "redeem" ? false : true;
    setIsBuying(buying);
  }, [history.location.hash]);

  return (
    <div className="default-container buy-equity-content page-layout">
          <div className="section-title-content mb-3">
          <div className="Page-title">Manage your EQUITY</div>
          <div className="Page-description mb-3">
            Mint{" "}
            <a href="https://docs.equalizer.exchange/Equity/overview/" target="_blank" rel="noopener noreferrer" className="ahreftextcolor">
              EQUITY
            </a>{" "}
            tokens by adding Liquidity. Stake your EQUITY in the{" "}
            <a href="./farm" className="ahreftextcolor">
              EQUITY Gauge
            </a>{" "}
            to Earn EQUAL & veEQUAL rewards!
            <br /><br />
            <i>Note: There is a minimum 15 minutes holding time after adding liquidity.</i>
          </div>
        </div>

      {/*    <div className="section-title-block">
        <div className="section-title-icon">
          <img src={BuyEquityIcon} alt="BuyEquityIcon" />
        </div>
        <div className="section-title-content">
          <div className="Page-title">+ / Redeem</div>
          <div className="Page-description">
            Purchase{" "}
            <a href="https://docs.equalizer.exchange/tokenomics/equity" target="_blank" rel="noopener noreferrer" className="ahreftextcolor">
              EQUITY tokens
            </a>{" "}
            to earn {nativeTokenSymbol} fees from swaps and leverages trading.
            <br />
            Note that there is a minimum holding time of 15 minutes after a purchase.
            <br />
            View <Link to="/earn" className="ahreftextcolor">staking</Link> page.
          </div>
        </div>
      </div> */}
      <EquitySwap {...props} isBuying={isBuying} setIsBuying={setIsBuying} />
      <Footer />
    </div>
  );
}
